// Api Configuration
export const appConfig = {
  BASE_URL: window["appConfig"].baseUrl,
  LOCALE: "fr-FR",
  NG_APP_ROOT: `${window["appConfig"].baseUrl}ClientApp/`,
};

export const clientConfig = {
  LOGO_URL: `${window["clientConfig"].merchantMediaUrl}/tenants/${window["clientConfig"].tenantName}/merchants/${window["clientConfig"].merchantName}/images/${window["clientConfig"].clientLogo}`,
  BANNER_JPG: `${window["clientConfig"].merchantMediaUrl}/tenants/${window["clientConfig"].tenantName}/merchants/${window["clientConfig"].merchantName}/images/banner.jpg`,
  UN_NO1: `${window["clientConfig"].merchantMediaUrl}/tenants/${window["clientConfig"].tenantName}/merchants/${window["clientConfig"].merchantName}/images/UN_NO1.png`,
  UN_NO2: `${window["clientConfig"].merchantMediaUrl}/tenants/${window["clientConfig"].tenantName}/merchants/${window["clientConfig"].merchantName}/images/UN_NO2.png`,
  UN_NO3: `${window["clientConfig"].merchantMediaUrl}/tenants/${window["clientConfig"].tenantName}/merchants/${window["clientConfig"].merchantName}/images/UN_NO3.png`,
  UN_NO4: `${window["clientConfig"].merchantMediaUrl}/tenants/${window["clientConfig"].tenantName}/merchants/${window["clientConfig"].merchantName}/images/UN_NO4.png`,
  TITLE: window["clientConfig"].title,
  MERCHANTMEDIAURL: `${window["clientConfig"].merchantMediaUrl}`,
  TENANTNAME: `${window["clientConfig"].tenantName}`,
  MERCHANTNAME: `${window["clientConfig"].merchantName}`,
  DESC: window["clientConfig"].description,
  THEME: window["clientConfig"].theme,
  APPFLOW: window["clientConfig"].appFlow,
  POLICYURL: window["clientConfig"].policyUrl,
  MERCHANT_ID: window["clientConfig"].merchantId,
  LANG: window["clientConfig"].lang,
  COUNTRIESALLOWED: window["clientConfig"].countriesAllowed,
  REDIRECT_URL: window["clientConfig"].redirectUrl,
  CANCEL_URI: window["clientConfig"].cancelUri,
  ERROR_URI: window["clientConfig"].errorUri,
  POSTBACK_URL: window["clientConfig"].postBackURL,
  POSTBACK_TOKEN: window["clientConfig"].postBackToken,
  RETURN_CENTER_ID: window["clientConfig"].returnCenterId,
  SHIPPING_OPTIONS: window["clientConfig"].shippingOptions,
  SHOW_REFUND: window["clientConfig"].showRefund,
  GOOGLE_API_KEY: window["clientConfig"].googleApiKey,
  EXTERNAL_ID: window["clientConfig"].externalId,
  ID_TYPE: window["clientConfig"].idType,
  TECH_SUPPORT_CONFIG: window["clientConfig"].techSupportConfig,
  Lead_Time_Config: window["clientConfig"].leadTimeConfig,
  LABEL_FORMAT: window["clientConfig"].labelFormat ? window["clientConfig"].labelFormat : "PDF",
  MERCHANTCONFIG_IN_DB: window["clientConfig"].merchantConfigInDatabase,
  CUSTOMER_SUPPORT_INPUT: window["clientConfig"].customerSupportInput,
  USE_EXTERNAL_INTEGRATION: window["clientConfig"].useExternalIntegration,
  EMAIL_NOTIFICATION_ENABLED: window["clientConfig"].emailNotificationEnabled,
  EXTERNAL_TEMPLATEIDS: window["clientConfig"].externalTemplateIds,
};

export const addressList = ["IN", "SE", "DE"];

export const errorMessages = {
  orderDataMissing:
    "Something has gone wrong and the application is missing critical information. Please contact Brando customer service for help.",
  noReturnableItem: "Order has no returnable items",
  lableNoCreated: "Error while creating lable, Please contact to admin",
};
